/* Stylesheet */

.item_option {
  background: var(--ion-gradient-dark);
  border-radius: 52px 0px 0px 52px;

  .wrapper_container {
    padding: 0px 8px 0px 6px;
    display: flex;
    align-items: center;

    .icon_container {
      display: flex;
      height: 38px;
      width: 38px;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border-radius: 52px;

      .icon {
        height: 21px;
        width: 21px;
        color: #3b4c65;
      }
    }

    .label {
      margin: 0px 21px 0px 21px;
      text-transform: none;
      font-size: 0.938rem;
    }
  }
}
